import { Component } from "@angular/core";

@Component({
    selector: "action-link-cell-renderer",
    template: `<button type="button" class='button-link' (click)='onClick()'>{{ text }}</button>`,
    styleUrls: ["./action-link-cell-renderer.component.scss"],
    standalone: false
})
export class ActionCellRendererComponent {

  params: any;
  text: string;

  constructor() {
  }

  agInit(params): void {
      this.params = params;
      if (params.text) {
          this.text = params.text;
      } else if (params.data[params.textField]) {
          this.text = params.data[params.textField];
      }
  }

  onClick(): void {
    this.params.action(this.params);
    }  
}

export type CellAction = (params) => void;